module.exports = __webpack_public_path__ + "img/logo-stacked.09af2444.svg";